"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable */
/*
 * SpriteSheet
 * Visit http://createjs.com/ for documentation, updates and examples.
 *
 * Copyright (c) 2010 gskinner.com, inc.
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPliED, INCLUDING BUT NOT liMITED TO THE WARRANTIES
 * OF MERCHANTABIliTY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HolDERS BE liABLE FOR ANY CLAIM, DAMAGES OR OTHER liABIliTY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEAliNGS IN THE SOFTWARE.
 */
/**
 * This is mostly the SpriteSheet class from easeljs with a few modifications
 */
var SpriteSheet = /*#__PURE__*/function () {
  function SpriteSheet(data, imgPrefix, onLoadComplete) {
    _classCallCheck(this, SpriteSheet);
    this.complete = true;
    this.framerate = 0;
    this._animations = null;
    this._frames = null;
    this._images = null;
    this._data = null;
    this._loadCount = 0;
    this._frameHeight = 0;
    this._frameWidth = 0;
    this._numFrames = 0;
    this._regX = 0;
    this._regY = 0;
    this._spacing = 0;
    this._margin = 0;
    this.onLoadComplete = onLoadComplete;
    this.imgPrefix = imgPrefix;
    this._parseData(data);
  }
  _createClass(SpriteSheet, [{
    key: "getAnimations",
    value: function getAnimations() {
      return this._animations.slice();
    }
  }, {
    key: "getAnimation",
    value: function getAnimation(name) {
      return this._data[name];
    }
  }, {
    key: "getFrame",
    value: function getFrame(frameIndex) {
      if (this._frames && this._frames[frameIndex]) {
        return this._frames[frameIndex];
      }
      return null;
    }
  }, {
    key: "getFrameBounds",
    value: function getFrameBounds(frameIndex) {
      var frame = this.getFrame(frameIndex);
      if (frame) {
        return {
          x: -frame.regX,
          y: -frame.regY,
          width: frame.rect.width,
          height: frame.rect.height
        };
      }
      return null;
    }
  }, {
    key: "getNumFrames",
    value: function getNumFrames(animation) {
      if (null === animation) {
        return this._frmaes ? this._frames.length : this._numFrames || 0;
      } else {
        var data = this._data[animation];
        if (null === data) {
          return 0;
        } else {
          return data.frames.length;
        }
      }
    }
  }, {
    key: "_parseData",
    value: function _parseData(data) {
      if (null === data) {
        return;
      }
      this.framerate = data.framerate || 0;

      // parse images
      if (data.images && data.images.length > 0) {
        this._images = [];
        for (var i = 0; i < data.images.length; i++) {
          var img = data.images[i];
          if (typeof img === 'string') {
            // image was string, not a source, so create a source
            var src = this.imgPrefix + img;
            img = document.createElement('img');
            img.src = src;
          }
          this._images.push(img);
          if (!img.getContext) {
            // we need to load the image
            this._loadCount++;
            this.complete = false;
            (function (scope, src) {
              img.onload = function () {
                scope._handleImageLoad(src);
              };
            })(this, src);
            (function (scope, src) {
              img.onerror = function () {
                scope._handleImageError(src);
              };
            })(this, src);
          }
        }
      }

      // parse frames
      if (null !== data.frames) {
        if (Array.isArray(data.frames)) {
          // frames is an array
          this._frames = [];
          for (var i = 0; i < data.frames.length; i++) {
            var arr = data.frames[i];
            this._frames.push({
              image: this._images[arr[4] ? arr[4] : 0],
              rect: {
                x: arr[0],
                y: arr[1],
                width: arr[2],
                height: arr[3]
              },
              regX: arr[5] || 0,
              regY: arr[6] || 0
            });
          }
        } else {
          // frames is an object ie all frames are the same
          this._frameWidth = data.frames.width;
          this._frameHeight = data.frames.height;
          this._regX = data.frames.regX || 0;
          this._regY = data.frames.regY || 0;
          this._spacing = data.frames.spacing || 0;
          this._margin = data.frames.margin || 0;
          this._numFrames = data.frames.count;
          if (this._loadCount == 0) {
            this._calculateFrames();
          }
        }
      }

      // parse animations
      this._animations = [];
      if (null !== data.animtions) {
        this._data = {};
        for (var name in data.animations) {
          var anim = {
            name: name
          };
          var obj = data.animations[name];
          if (typeof obj === 'number') {
            // single frame animation
            anim.frames = [obj];
          } else if (Array.isArray(obj)) {
            // simple animation array
            if (obj.length === 1) {
              anim.frames = [obj[0]];
            } else {
              anim.speed = obj[3];
              anim.next = obj[2];
              anim.frames = [];
              for (var i = obj[0]; i <= obj[1]; i++) {
                anim.frames.push(i);
              }
            }
          } else {
            // complex animation object
            anim.speed = obj.speed;
            anim.next = obj.next;
            if (typeof frames === 'number') {
              anim.frames = [obj.frames];
            } else {
              anim.frames = obj.frames.slice();
            }
          }
          if (anim.next === true || anim.next === undefined) {
            // loop
            anim.next = name;
          }
          if (anim.next === false || anim.frames < 2 && anim.next === name) {
            //stop
            anim.next = null;
          }
          if (!anim.speed) {
            anim.speed = 1;
          }
          this._animations.push(name);
          this._data[name] = anim;
        }
      }
    }
  }, {
    key: "_handleImageLoad",
    value: function _handleImageLoad(src) {
      if (--this._loadCount === 0) {
        this._calculateFrames();
        this.complete = true;
        if (this.onLoadComplete) {
          this.onLoadComplete();
        }
      }
    }
  }, {
    key: "_handleImageError",
    value: function _handleImageError(src) {
      console.error('Error loading image: ', src);
      if (--this._loadCount === 0 && this.onLoadComplete) {
        // still call complete even on error
        this.onLoadComplete();
      }
    }
  }, {
    key: "_calculateFrames",
    value: function _calculateFrames() {
      if (this._frames || this._frameWidth === 0) {
        // nothing to work with
        return;
      }
      this._frames = [];
      var maxFrames = this._numFrames || Number.MAX_SAFE_INTEGER;
      var frameCount = 0;
      imgLoop: for (var i = 0; i < this._images.length; i++) {
        var img = this._images[i],
          imgW = img.width,
          imgH = img.height;
        var y = this._margin;
        while (y <= imgH - margin - this._frameHeight) {
          var x = this._margin;
          while (x <= imgW - margin - this._frameWidth) {
            if (frameCount >= maxFrames) {
              break imgLoop;
            }
            frameCount++;
            this._frames.push({
              image: img,
              rect: {
                x: x,
                y: y,
                width: this._frameWidth,
                height: this._frameHeight
              },
              regX: this._regX,
              regY: this._regY
            });
            x += this._frameWidth + spacing;
          }
          y += this._frameHeight + spacing;
        }
      }
      this._numFrames = frameCount;
    }
  }]);
  return SpriteSheet;
}();
exports["default"] = SpriteSheet;